<template>
  <div class="swap">
    <div class="title">
      <p>Flash Loan BETA</p>
      <p style="margin-left: 5px; color: red">(UPDATED 13 Aug 2021)</p>
    </div>

    <div class="input_element">
      <div class="name">
        <p style="white-space: nowrap">Token Name</p>
      </div>
      <input type="text" class="modal-input" placeholder="Enter Token" v-model="tokenName">
    </div>
    <p v-if="showNameError" class="error">Provide Token Name</p>

    <div class="input_element">
      <div class="name">
        <p style="white-space: nowrap">Token Symbol</p>
      </div>
      <input type="text" class="modal-input" placeholder="Enter Symbol" v-model="tokenSymbol">
    </div>
    <p v-if="showSymbolError" class="error">Provide Symbol Name</p>

    <div class="input_element">
      <div class="name">
        <p style="white-space: nowrap">Loan Amount</p>
      </div>
      <input type="number" v-model="inputValue" class="modal-input" readonly>
      <div class="buttons">
        <div class="arrow_button" @click="increase">
          +
        </div>
        <div class="arrow_button" @click="decrease">
          -
        </div>
      </div>
    </div>
    <p v-if="showValueError" class="error">Value must be greater than 5</p>

    <Input4/>
    <Result/>
    <Button v-if="!connected"/>
    <ButtonLoan v-else/>
  </div>
</template>

<script>
import Button from "@/components/Button";
import Input4 from "@/components/Input4";
import Result from "@/components/Result";
import {bus} from "@/main";
import ButtonLoan from "@/components/ButtonLoan";

export default {
  name: "Swap",
  components: {ButtonLoan, Result, Input4, Button},
  created() {
    bus.$on('chain-changed', this.chainChanged);
    bus.$on('wallet-connected', this.walletConnected);
    bus.$on('execute', this.execute);
  },
  beforeDestroy() {
    bus.$off('chain-changed', this.chainChanged);
    bus.$off('wallet-connected', this.walletConnected);
    bus.$off('execute', this.execute);
  },
  data: function () {
    return {
      connected: false,
      inputValue: 5,
      tokenName: "",
      tokenSymbol: "",
      showNameError: false,
      showSymbolError: false,
      showValueError: false
    };
  },
  methods: {
    walletConnected: function () {
      this.connected = true;
    },
    increase: function () {
      this.inputValue = +this.inputValue + 5
      bus.$emit('increased')
    },
    decrease: function () {
      if (this.inputValue > 5) {
        this.inputValue -= 5
        bus.$emit('decreased')
      }
    },
    chainChanged: function () {
      this.inputValue = 5
    },
    execute: function () {
      this.showNameError = this.tokenName === "";
      this.showSymbolError = this.tokenName === "";
      this.showValueError = this.inputValue < 5;

      if (this.showNameError || this.showSymbolError || this.showValueError) {
        return
      }

      bus.$emit('need-total')
    }
  }
}
</script>

<style scoped>
.swap {
  display: flex;
  flex-direction: column;

  max-width: 500px;
  width: 100%;

  background: rgb(25, 27, 31);
  box-shadow: rgba(0, 0, 0, 0.01) 0px 0px 1px, rgba(0, 0, 0, 0.04) 0px 4px 8px, rgba(0, 0, 0, 0.04) 0px 16px 24px, rgba(0, 0, 0, 0.01) 0px 24px 32px;
  border-radius: 24px;

  padding: 8px;
}

.title {
  display: flex;
  justify-content: start;
  padding: 1rem 1.25rem 0.5rem;
  font-weight: 500;
  font-size: 16px;
}

.input_element {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  padding: 15px;

  border-radius: 20px;
  border: 1px solid rgb(44, 47, 54);
  background-color: rgb(33, 36, 41);
}

.name {
  font-size: 20px;
  font-weight: 600;
  background-color: rgb(33, 114, 229);
  color: rgb(255, 255, 255);
  border-radius: 16px;
  box-shadow: rgba(0, 0, 0, 0.075) 0px 6px 10px;
  padding: 10px;
}

.modal-input {
  border: 0;
  background: 0 0;
  padding: 8px 30px;
  height: 40px;
  width: 100%;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}

.buttons {
  display: flex;
  flex-direction: column;
}

.arrow_button {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 50px;
  height: 30px;

  border-radius: 20px;
  background-color: rgb(44, 47, 54);

  font-size: 15pt;
  font-weight: 600;

  cursor: pointer;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                   supported by Chrome, Edge, Opera and Firefox */
}

.error {
  margin-top: 10px;
  color: red;
}

.arrow_button:last-child {
  margin-top: 5px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>